/* BYON · Hero C + oferta flash (ronda 11, bloque A). Sin librerías; defer desde sections/byon-home-hero-c.liquid.
   Rota solo en computador (>=990 px, mouse) y sin "reducir movimiento": la barra de la pestaña anima N s y al terminar
   pasa al siguiente. Pausa: mouse, foco, menú/carro abiertos, fuera de pantalla. Se detiene: pestaña, deslizar, pausa o
   2 vueltas. Pestañas ARIA (flechas, Inicio, Fin). Flash: cuenta regresiva (hora de Chile), agregar al carro (K2),
   bases en <dialog>. Medición K1 (byonTrack). QA: ?byon_now=AAAA-MM-DD%20HH:MM */
(function () {
  'use strict';
  if (window.BYONHeroC) return;
  var W = window, D = document, RE = /^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d)$/,
    RM = matchMedia('(prefers-reduced-motion: reduce)').matches,
    ev = function (n, p) { (W.byonTrack || function () {})(n, p); },
    all = function (r, s) { return [].slice.call(r.querySelectorAll(s)); };

  function nowCL() {
    var q = location.search.match(/[?&]byon_now=([^&]+)/), p = {};
    if (q) { q = decodeURIComponent(q[1].replace(/\+/g, ' ')); if (RE.test(q)) return q; }
    try {
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return p.year + '-' + p.month + '-' + p.day + ' ' + (p.hour === '24' ? '00' : p.hour) + ':' + p.minute;
    } catch (e) { return null; }
  }
  function mins(s) { var m = RE.exec(s || ''); return m ? Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]) / 6e4 : NaN; }
  function left(to, n) { var d = mins(to) - mins(n); return isNaN(d) ? -1 : d; }
  function inWin(el, n) { var a = el.getAttribute('data-start') || '', b = el.getAttribute('data-end') || ''; return (!a || n >= a) && (!b || n <= b); }
  function fmt(m) { var d = Math.floor(m / 1440), h = Math.floor(m % 1440 / 60), i = Math.floor(m % 60); return d ? d + ' d ' + h + ' h' : h ? h + ' h ' + i + ' min' : i + ' min'; }

  function hero(root) {
    var tr = root.querySelector('[data-hc-track]'), tl = root.querySelector('[role="tablist"]'), car = root.querySelector('[data-hc-car]'),
      pb = root.querySelector('[data-hc-pause]'), n = nowCL(), S, T, cur = 0, stop = 0, loops = 0, prog = 0, vis = 0, wake = 0, ch = 0,
      P = {}, seen = {}, pt, vt, raf,
      auto = root.getAttribute('data-autoplay') === '1' && !RM && matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
    if (!tr || !tl) return;
    if (n) all(tr, '[data-sched]').forEach(function (s) {
      var t = D.getElementById(s.getAttribute('data-tab')), h = !inWin(s, n);
      if (s.hidden !== h) { s.hidden = h; ch = 1; }
      if (t) t.hidden = h;
    });
    /* Slides que se pintan: vigentes y no ocultos por CSS (R2-UX-10: desde 990 px, con un evento en la columna, los
       slides de campaña no se pintan). Se recalcula al cruzar 990 px y cuando cambia la columna. */
    function build() {
      S = all(tr, '[role="tabpanel"]').filter(function (s) { return !s.hidden && s.offsetParent !== null; });
      T = S.map(function (s) { return D.getElementById(s.getAttribute('data-tab')); });
      S.forEach(function (s, i) { s.setAttribute('aria-label', (i + 1) + ' de ' + S.length); });
    }
    build();
    if (!S.length) return;
    /* Si la página venía de caché y cambió qué slides rigen, se vuelve al primero (la campaña activa va 1.ª) */
    if (ch) tr.scrollLeft = 0;
    auto = auto && S.length > 1;
    tr.setAttribute('aria-live', auto ? 'off' : 'polite');

    function warm(i) { all(S[i % S.length], 'img[loading="lazy"]').forEach(function (m) { m.loading = 'eager'; }); }
    function look(i) {
      clearTimeout(vt);
      if (seen[i] || !vis) return;
      vt = setTimeout(function () {
        if (cur !== i || D.hidden || !vis) return;
        seen[i] = 1;
        ev('view_promotion', { creative_slot: 'hero_' + (i + 1), promotion_name: S[i].getAttribute('data-name') || '' });
      }, 1000);
    }
    function sel(i, scroll) {
      cur = i = (i + S.length) % S.length;
      T.forEach(function (t, k) { t.setAttribute('aria-selected', k === i); t.tabIndex = k === i ? 0 : -1; });
      S.forEach(function (s, k) { s.inert = k !== i; });
      if (scroll) {
        prog = 1; clearTimeout(pt); pt = setTimeout(function () { prog = 0; }, 800);
        tr.scrollTo({ left: S[i].offsetLeft, behavior: RM ? 'auto' : 'smooth' });
      }
      look(i);
      if (wake) warm(i + 1);
    }
    function paint() { root.classList.toggle('is-paused', !!(stop || P.w || P.h || P.f || P.o || P.v || P.x)); }
    function halt() {
      if (!auto || stop) return;
      stop = 1; root.classList.add('is-stopped'); tr.setAttribute('aria-live', 'polite');
      if (pb) { pb.classList.add('is-play'); pb.setAttribute('aria-label', 'Reanudar la rotación'); }
      paint();
    }
    function play() {
      stop = loops = P.h = P.f = 0; root.classList.remove('is-stopped'); tr.setAttribute('aria-live', 'off');
      pb.classList.remove('is-play'); pb.setAttribute('aria-label', 'Pausar la rotación');
      paint();
    }

    tl.addEventListener('click', function (e) {
      var i = T.indexOf(e.target.closest('[role="tab"]'));
      if (i < 0) return;
      e.preventDefault(); wake = 1; halt(); sel(i, 1);
    });
    tl.addEventListener('keydown', function (e) {
      var i = T.indexOf(D.activeElement), k = e.key,
        j = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? T.length - 1 : null;
      if (i < 0 || j === null) return;
      e.preventDefault(); wake = 1; halt(); sel(j, 1); T[cur].focus();
    });
    tr.addEventListener('scroll', function () {
      if (prog) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(tr.scrollLeft / (tr.clientWidth || 1));
        if (i !== cur && S[i]) { halt(); sel(i); }
      });
    }, { passive: true });
    tr.addEventListener('scrollend', function () { prog = 0; });
    tr.addEventListener('click', function (e) { if (prog) { e.preventDefault(); e.stopPropagation(); } }, true);
    tr.addEventListener('touchstart', function () { if (!wake) { wake = 1; warm(cur + 1); } }, { passive: true });
    W.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { prog = 1; tr.scrollLeft = S[cur].offsetLeft; setTimeout(function () { prog = 0; }, 100); });
    });
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (x) { vis = x[0].intersectionRatio >= 0.5; P.o = !vis; paint(); if (vis) look(cur); }, { threshold: [0, 0.5] }).observe(car);
    } else vis = 1;

    if (auto) {
      root.classList.add('is-auto'); P.w = 1; P.v = D.hidden; paint();
      /* TEC 15a: la foto del slide siguiente se pide recién después de load + 1 s (no compite con la foto LCP) */
      var go = function () { setTimeout(function () { P.w = 0; paint(); if (!wake && !(navigator.connection && navigator.connection.saveData)) { wake = 1; warm(cur + 1); } }, 1000); };
      if (D.readyState === 'complete') go(); else W.addEventListener('load', go);
      car.addEventListener('mouseenter', function () { P.h = 1; paint(); });
      car.addEventListener('mouseleave', function () { P.h = 0; paint(); });
      root.addEventListener('focusin', function () { P.f = 1; paint(); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { P.f = 0; paint(); } });
      D.addEventListener('visibilitychange', function () { P.v = D.hidden; paint(); });
      new MutationObserver(function () { P.x = D.body.classList.contains('byon-overlay-open'); paint(); }).observe(D.body, { attributes: true, attributeFilter: ['class'] });
      if (pb) pb.addEventListener('click', function () { if (stop) play(); else halt(); });
      tr.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) halt(); }, { passive: true });
      tl.addEventListener('animationend', function (e) {
        if (stop || e.target.closest('[role="tab"]') !== T[cur]) return;
        if (cur === S.length - 1 && ++loops >= 2) { halt(); sel(0, 1); } else sel(cur + 1, 1);
      });
    }
    root.__hcSel = function (s) { var i = S.indexOf(s); if (i >= 0) { halt(); sel(i, 1); } };
    root.__hcBuild = function () {
      var was = S[cur], i;
      build();
      if (!S.length) return;
      seen = {};
      i = Math.max(0, S.indexOf(was));
      prog = 1; clearTimeout(pt); pt = setTimeout(function () { prog = 0; }, 100);
      tr.scrollLeft = S[i].offsetLeft;
      sel(i);
    };
    var mqD = matchMedia('(min-width: 990px)');
    if (mqD.addEventListener) mqD.addEventListener('change', root.__hcBuild); else if (mqD.addListener) mqD.addListener(root.__hcBuild);
    sel(Math.min(S.length - 1, Math.round(tr.scrollLeft / (tr.clientWidth || 1))));
  }

  function flash(root) {
    var box = root.querySelector('[data-hc-flash]'), fb = root.querySelector('[data-hc-fb]'), sd = root.querySelector('[data-hc-side]'),
      evs = all(root, '[data-hc-ev]'), cds = all(root, '[data-hc-cd-to]');
    /* Columna lateral: flash > 1.er modo evento vigente > respaldo. Sin flash, bajo 990 px no se pinta (UX 10) */
    function side(n) {
      var fl = !!(box && !box.hidden), got = 0, ev;
      evs.forEach(function (e) { var on = !fl && !got && inWin(e, n); e.hidden = !on; if (on) got = 1; });
      if (fb) fb.hidden = fl || !!got;
      if (sd) sd.classList.toggle('byon-hc__side--nofl', !fl);
      ev = !fl && !!got;
      if (ev !== root.classList.contains('byon-hc--ev')) {
        root.classList.toggle('byon-hc--ev', ev);
        if (root.__hcBuild) root.__hcBuild();
      }
    }
    function tick() {
      var n = nowCL();
      if (!n) return;
      cds.forEach(function (p) { var l = left(p.getAttribute('data-hc-cd-to'), n), b = p.querySelector('[data-hc-cd]'); if (l <= 0) p.hidden = true; else if (b) b.textContent = fmt(l); });
      if (box && !box.hidden) {
        var l = left(box.getAttribute('data-end'), n);
        if (l <= 0 || !inWin(box, n)) box.hidden = true;
        else all(box, '[data-hc-cd]').forEach(function (c) { c.textContent = fmt(l); });
      }
      side(n);
    }
    tick(); setInterval(tick, 30000);
    all(root, '[data-hc-bases]').forEach(function (x) {
      var d = D.getElementById(x.getAttribute('aria-controls'));
      if (!d || !d.showModal) return;
      x.addEventListener('click', function () { d.showModal(); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });
    if (!box) return;
    var b = box.querySelector('[data-hc-atc][data-variant]'), msg = box.querySelector('[data-hc-msg]'), t2, io;
    if (b) b.addEventListener('click', function () {
      if (b.getAttribute('aria-busy') === 'true') return;
      var id = b.getAttribute('data-variant'), C = W.byonCart;
      b.setAttribute('aria-busy', 'true'); msg.textContent = '';
      if (C && C.markOwn) C.markOwn();
      fetch(((W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          var it = (j.items && j.items[0]) || {};
          ev('add_to_cart', { atc_source: 'home_flash', item_id: String(it.product_id || ''), variant_id: String(id), item_name: it.product_title || box.getAttribute('data-name'), price: Math.round((it.final_price || it.price || 0) / 100), quantity: 1, currency: 'CLP', promotion_id: box.getAttribute('data-promo') });
          if (C && C.refreshDrawer) C.refreshDrawer(true); else location.href = (W.routes && W.routes.cart_url) || '/cart';
        })
        .catch(function (e) { msg.textContent = (e && e.description) || 'No pudimos agregar el producto. Inténtalo de nuevo.'; })
        .then(function () { b.removeAttribute('aria-busy'); });
    });
    if ('IntersectionObserver' in W) {
      io = new IntersectionObserver(function (x) {
        clearTimeout(t2);
        if (x[0].intersectionRatio >= 0.5) t2 = setTimeout(function () {
          if (box.hidden) return;
          io.disconnect();
          ev('view_promotion', { creative_slot: 'home_flash', promotion_id: box.getAttribute('data-promo'), promotion_name: box.getAttribute('data-name') });
        }, 1000);
      }, { threshold: [0, 0.5] });
      io.observe(box);
    }
  }

  function init(s) { all(s || D, '[data-byon-hc]').forEach(function (r) { if (r.__hc) return; r.__hc = 1; hero(r); flash(r); }); }
  W.BYONHeroC = { init: init, nowCL: nowCL };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
  D.addEventListener('shopify:block:select', function (e) { var r = e.target.closest && e.target.closest('[data-byon-hc]'); if (r && r.__hcSel) r.__hcSel(e.target); });
})();
